
import { onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  setup() {
    onMounted(() => {
      const elements = document.querySelectorAll('.ani-top');
      gsap.set(elements, { opacity: 0, y: -30 });
      gsap.to(elements, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        stagger: 0.2
      });
    });
  }
};
